import { Component, computed, signal, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

import { LoadingComponent } from '../loading.component/loading.component';
import { eLead } from '../../core/services/entities';

import { GsapService } from '../../core/services/gsap.service';
import { HaylieService } from '../../core/services/haylie.service';
import { ModalService } from '../../core/services/modal.service';
import { MasterService } from '../../core/services/master.service';
import { SignalService } from '../../core/services/signal.service';
import { VesperService } from '../../core/services/vesper.service';

@Component({
  standalone: true,
  selector: 'app-form',
  imports: [CommonModule, ReactiveFormsModule, LoadingComponent, NgxMaskDirective],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss'
})
export class FormComponent {

  s_frm_name = signal(true);
  s_frm_mail = signal(true);
  s_frm_phone = signal(true);

  frmname = new FormControl('');
  frmmail = new FormControl('');
  frmphone = new FormControl('');

  s_modal = Inject(ModalService).modal;
  s_loading = Inject(SignalService).frm_loading;
  b_loading = computed(() => this.s_loading());

  constructor(private gsap: GsapService, 
              private haylie: HaylieService,
              private vesper: VesperService, 
              private _svc_modal:ModalService, 
              private _svc_master:MasterService, 
              private _svc_signal:SignalService
            ) {
              this.s_modal = this._svc_modal.modal;
              this.s_loading = this._svc_signal.frm_loading;
            }

  ngOnInit() { 
      //this.vesper.logmein(); 
  }

  frm_close(): void { 
    this._svc_master.trg_master('close-all'); 
  }

  frm_send(event: SubmitEvent):void {
    event.preventDefault();

    var obj = new eLead();
    obj.id = '0';
    this.s_frm_name.set(true);
    this.s_frm_mail.set(true);
    this.s_frm_phone.set(true);

    if (this.frmname.value == null) this.s_frm_name.set(false);
    else {  
      if (this.frmname.value.length <= 0) this.s_frm_name.set(false);
      else 
        obj.name = this.frmname.value;
    
    }

    if (this.frmmail.value == null) this.s_frm_mail.set(false);
    else {
      if (this.frmmail.value.length <= 0) this.s_frm_mail.set(false);
      else
        obj.mail =  this.frmmail.value;

    }

    if (this.frmphone.value == undefined) this.s_frm_phone.set(false);
    else {
      if (this.frmphone.value.length <= 0) this.s_frm_phone.set(false);
      else  
        obj.phone =  this.frmphone.value;
    }

    if (this.s_frm_name() && this.s_frm_mail() && this.s_frm_phone()) {
      this._svc_master.trg_master("loading");

      obj.birth = this._svc_signal.modal_type();
      // if (this._svc_signal.modal_type() == "modal-talk")
      //   this.vesper.send_lead(obj);
      // else 
        this.haylie.send_frm(obj, this._svc_signal.modal_type().replace("modal-",""));
      
    }
    else {
      setTimeout(() => {
        this.s_frm_name.set(true);
        this.s_frm_mail.set(true);
        this.s_frm_phone.set(true);
      }, 3000)
      
    }



  }

}
